import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.is-finite";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { omit } from 'helpers/object';
export var TAX_AMOUNT_NOT_LOADED = -1;
export var TAX_METHOD_LEGACY = 1;
export var TAX_METHOD_TAXSERVICE = 2;
var ADD_CART_ITEM = 'classpass/cart/ADD_CART_ITEM';
var REMOVE_CART_ITEM = 'classpass/cart/REMOVE_CART_ITEM';
var UPDATE_CART_ITEM = 'classpass/cart/UPDATE_CART_ITEM';
var EMPTY_CART = 'classpass/cart/EMPTY_CART';
var SET_TAX_TOTAL = 'classpass/cart/SET_TAX_TOTAL';
var SET_TAX_METHOD = 'classpass/cart/SET_TAX_METHOD';
var SET_CART_CURRENCY = 'classpass/cart/SET_CART_CURRENCY';
var SET_CART_POSTAL_CODE = 'classpass/cart/SET_CART_POSTAL_CODE';
export var addCartItem = function addCartItem(itemId, name, amount) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$description = _ref.description,
      description = _ref$description === void 0 ? null : _ref$description,
      _ref$hidden = _ref.hidden,
      hidden = _ref$hidden === void 0 ? false : _ref$hidden,
      _ref$isFree = _ref.isFree,
      isFree = _ref$isFree === void 0 ? false : _ref$isFree,
      _ref$isCredit = _ref.isCredit,
      isCredit = _ref$isCredit === void 0 ? false : _ref$isCredit,
      _ref$isPostTaxDiscoun = _ref.isPostTaxDiscount,
      isPostTaxDiscount = _ref$isPostTaxDiscoun === void 0 ? false : _ref$isPostTaxDiscoun,
      _ref$isDebit = _ref.isDebit,
      isDebit = _ref$isDebit === void 0 ? !isCredit && !isPostTaxDiscount : _ref$isDebit,
      _ref$isTaxable = _ref.isTaxable,
      isTaxable = _ref$isTaxable === void 0 ? !isPostTaxDiscount : _ref$isTaxable,
      _ref$displayAmount = _ref.displayAmount,
      displayAmount = _ref$displayAmount === void 0 ? amount : _ref$displayAmount,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? null : _ref$content,
      _ref$sku = _ref.sku,
      sku = _ref$sku === void 0 ? '' : _ref$sku,
      _ref$planCode = _ref.planCode,
      planCode = _ref$planCode === void 0 ? '' : _ref$planCode;

  return {
    type: ADD_CART_ITEM,
    data: {
      description: description,
      itemId: itemId,
      name: name,
      amount: amount * 100,
      isFree: isFree,
      isTaxable: isTaxable,
      isCredit: isCredit,
      isDebit: isDebit,
      isPostTaxDiscount: isPostTaxDiscount,
      displayAmount: displayAmount,
      content: content,
      hidden: hidden,
      weight: 0,
      sku: sku,
      planCode: planCode
    }
  };
};
export var removeCartItem = function removeCartItem(itemId) {
  return {
    type: REMOVE_CART_ITEM,
    data: {
      itemId: itemId
    }
  };
};
export var updateCartItem = function updateCartItem(itemId) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref2$amount = _ref2.amount,
      amount = _ref2$amount === void 0 ? Infinity : _ref2$amount,
      overrides = _objectWithoutProperties(_ref2, ["amount"]);

  return {
    type: UPDATE_CART_ITEM,
    data: _objectSpread({
      itemId: itemId
    }, overrides, {
      amount: amount * 100,
      displayAmount: amount
    })
  };
};
export var emptyCart = function emptyCart() {
  return {
    type: EMPTY_CART
  };
};
export var setTaxMethod = function setTaxMethod(method) {
  return {
    type: SET_TAX_METHOD,
    data: {
      method: method
    }
  };
};
export var setTaxOnCart = function setTaxOnCart(taxTotal) {
  return {
    type: SET_TAX_TOTAL,
    data: {
      taxTotal: taxTotal
    }
  };
};
export var setCartCurrency = function setCartCurrency(currencyCode) {
  return {
    type: SET_CART_CURRENCY,
    data: {
      currencyCode: currencyCode
    }
  };
};
export var setCartPostalCode = function setCartPostalCode(postalCode) {
  return {
    type: SET_CART_POSTAL_CODE,
    data: {
      postalCode: postalCode
    }
  };
};
export var selectCart = function selectCart(state) {
  return state.cart;
};
var initialState = {
  taxMethod: TAX_METHOD_TAXSERVICE,
  currencyCode: 'USD',
  postalCodeForTaxes: '',
  debitTotal: 0,
  creditTotal: 0,
  subTotal: 0,
  taxTotal: TAX_AMOUNT_NOT_LOADED,
  grandTotal: 0,
  items: []
};

var selectCredits = function selectCredits(item) {
  return !!item.isCredit;
};

var selectDebits = function selectDebits(item) {
  return !!item.isDebit && !item.isFree;
};

var selectPostTaxDiscounts = function selectPostTaxDiscounts(item) {
  return !!item.isPostTaxDiscount;
};

var amountSummer = function amountSummer(memo, item) {
  return memo + item.amount;
};

var selectLegacyTaxableItems = function selectLegacyTaxableItems(item) {
  return !!item.isTaxable;
};

var sortByWeight = function sortByWeight(a, b) {
  return b.weight - a.weight;
};

var calculateTotals = function calculateTotals(state) {
  var debitTotal = state.items.filter(selectDebits).reduce(amountSummer, 0);
  var creditTotal = state.items.filter(selectCredits).reduce(amountSummer, 0);
  var postTaxDiscountTotal = state.items.filter(selectPostTaxDiscounts).reduce(amountSummer, 0);
  var taxAmount = Math.max(state.taxTotal, 0) * 100;
  var subTotal;
  /**
   * Taxes for gift cards (aka post-tax discounts) are handled differently (actually, wrongly)
   * in the legacy code path. So, if we're in legacy mode, we need to recreate the incorrect
   * behaviour. See also: `legacyTaxableTotal`.
   *
   * Example given a $75 plan, $50 gift card:
   *
   * Legacy: $75 - $50 = $25 net, charge tax on the $25 to get grand total
   * Tax service (avalara): Charge tax on $75, then less $50 to get grand total
   */

  var grandTotal;

  if (state.taxMethod === TAX_METHOD_TAXSERVICE) {
    subTotal = debitTotal - creditTotal;
    grandTotal = (subTotal + taxAmount - postTaxDiscountTotal) / 100;
  } else {
    subTotal = debitTotal - creditTotal - postTaxDiscountTotal;
    grandTotal = (subTotal + taxAmount) / 100;
  }

  return _objectSpread({}, state, {
    debitTotal: debitTotal / 100,
    creditTotal: creditTotal / 100,
    postTaxDiscountTotal: postTaxDiscountTotal / 100,
    subTotal: subTotal / 100,
    grandTotal: grandTotal
  });
};

export var legacyTaxableTotal = function legacyTaxableTotal(state) {
  var debitItems = state.items.filter(selectDebits);
  var creditItems = state.items.filter(selectCredits);
  var taxableDebits = debitItems.filter(selectLegacyTaxableItems);
  var taxableCredits = creditItems.filter(selectLegacyTaxableItems);
  var taxableDebitTotal = taxableDebits.reduce(amountSummer, 0);
  var taxableCreditTotal = taxableCredits.reduce(amountSummer, 0);
  var postTaxDiscountTotal = state.items.filter(selectPostTaxDiscounts).reduce(amountSummer, 0); // to implement incorrect legacy tax behaviour, we subtract post-tax discounts from taxable total

  return taxableDebitTotal - taxableCreditTotal - postTaxDiscountTotal;
};
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref3 = action.data || {},
      itemId = _ref3.itemId;

  switch (action.type) {
    case EMPTY_CART:
      return initialState;

    case REMOVE_CART_ITEM:
      return calculateTotals(_objectSpread({}, state, {
        items: state.items.filter(function (item) {
          return item.itemId !== itemId;
        })
      }));

    case ADD_CART_ITEM:
      return calculateTotals(_objectSpread({}, state, {
        items: state.items.filter(function (item) {
          return item.itemId !== itemId;
        }).concat(action.data).sort(sortByWeight)
      }));

    case UPDATE_CART_ITEM:
      return calculateTotals(_objectSpread({}, state, {
        items: state.items.map(function (item) {
          return item.itemId === itemId ? _objectSpread({}, item, Number.isFinite(action.data.amount) ? action.data : omit(['amount', 'displayAmount'], action.data)) : item;
        }).sort(sortByWeight)
      }));

    case SET_TAX_TOTAL:
      return calculateTotals(_objectSpread({}, state, {
        taxTotal: action.data.taxTotal
      }));

    case SET_CART_CURRENCY:
      return _objectSpread({}, state, {
        currencyCode: action.data.currencyCode
      });

    case SET_CART_POSTAL_CODE:
      return _objectSpread({}, state, {
        postalCodeForTaxes: action.data.postalCode
      });

    case SET_TAX_METHOD:
      return _objectSpread({}, state, {
        taxMethod: action.data.method
      });

    default:
      return state;
  }
}